<!-- Regular Header -->
@if (transparent() && !wizard()) {
  <div
    class="header-wrapper"
    [class.hidden]="!isMobile()"
    [class.transparent]="transparent()"
    [class.mobile]="isMobile()"
  >
    <div class="loctite-logo">
      <a aria-label="Home" [routerLink]="['/home']">
        <img
          id="loctite-logo"
          alt="Logo"
          src="assets/images/LoctitePulseLogo.svg"
        />
      </a>
    </div>
    <div class="more-info-content">
      <button
        class="ga-icon-button floating-btn"
        aria-label="settings"
        (click)="toSettings()"
      >
        <i nz-icon nzType="icons:more-information" class="noMarginRight"></i>
      </button>
    </div>

    <app-banner-notification></app-banner-notification>
  </div>
}

<!-- Asset/Plant Header -->
@if (cfg.appName === "ia" && !transparent() && !wizard()) {
  <div
    class="header-wrapper multiple-btns"
    [class.opaque]="!transparent()"
    [class.overlap]="overlap()"
    [class.mobile]="isMobile()"
    [class.tablet]="isTablet()"
  >
    @if (!backButtonClickInstead()) {
      <a class="back-btn" [routerLink]="[backRoute()]" aria-label="label">
        <i nz-icon nzType="icons:arrow-left" class="svg-icon"></i>
        @if (!isMobile()) {
          <span class="body-bold">{{ backLabel() }}</span>
        }
      </a>
    } @else {
      <a
        class="back-btn"
        tabindex="0"
        role="button"
        (click)="onBackButtonClick()"
        (keyup.enter)="onBackButtonClick()"
        aria-label="label"
      >
        <i nz-icon nzType="icons:arrow-left" class="svg-icon"></i>
        @if (!isMobile()) {
          <span class="body-bold">{{ backLabel() }}</span>
        }
      </a>
    }

    @if (isMobile()) {
      <div class="header-content mobile">
        <span class="body-bold">{{ backLabel() }}</span>
      </div>
    }

    @if (isMobile() && !isOnSettingsPage()) {
      <button
        class="ga-icon-button floating-btn"
        aria-label="settings"
        (click)="toSettings()"
      >
        <i nz-icon nzType="icons:more-information" class="noMarginRight"></i>
      </button>
    }

    @if (!isMobile()) {
      <app-tab-menu [header]="true" [navigation]="false"></app-tab-menu>
    }

    @if (noEditBtn()) {
      <span class="placeholder-span"></span>
    }
  </div>
}
<!-- Wizard Header -->
@if (wizard()) {
  <div
    class="header-wrapper wizard-header"
    [class.opaque]="!transparent()"
    [class.noLabel]="noLabelWizard()"
    [class.overlap]="overlap()"
    [class.mobile]="isMobile()"
    [class.desktop]="!isMobile()"
  >
    <div class="header-content">
      @if (overflowStart() && isMobile() && !isTablet()) {
        <div class="wizardbubble">
          <span class="wizardnumber overFlowStep overFlowStart">...</span>
        </div>
        <span class="wizardline greenLine"></span>
      }

      @for (bubble of wizardsteps(); track i; let i = $index) {
        @if (i > 0) {
          <span
            class="wizardline"
            [class.greenLine]="i + start() <= currentstep()"
          ></span>
        }

        <div
          class="wizardbubble"
          [class.errorStep]="
            i + start() === currentstep() && currentstepError()
          "
          [class.currentStep]="
            i + start() === currentstep() && !currentstepError()
          "
          [class.pastStep]="i + start() < currentstep()"
          tabindex="0"
          role="button"
          (click)="onWizardButtonClick(i)"
          (keyup.enter)="onWizardButtonClick(i)"
        >
          <span class="wizardnumber">
            @if (i + start() === currentstep() && !currentstepError()) {
              {{ i + 1 + start() }}
            }
            @if (i + start() === currentstep() && currentstepError()) {
              <i
                nz-icon
                nzType="icons:exit"
                class="svg-icon mini-icon fillwhite"
              ></i>
            }
            @if (i + start() > currentstep()) {
              {{ i + 1 + start() }}
            }
            @if (i + start() < currentstep()) {
              <i nz-icon nzType="icons:check" class="svg-icon mini-icon"></i>
            }
          </span>
          @if (!noLabelWizard()) {
            <span class="detail-bold wizardlabel">{{ bubble }}</span>
          }
        </div>
      }

      @if (overflowEnd() && currentstep() < 4 && isMobile() && !isTablet()) {
        <span class="wizardline"></span>
        <div class="wizardbubble">
          <span class="wizardnumber overFlowStep">...</span>
        </div>
      }
    </div>
  </div>
}

<!-- EM asset/plant header -->
@if (cfg.appName === "em" && !transparent()) {
  <div
    class="header-wrapper"
    [class.hidden]="isDesktop()"
    [class.opaque]="!transparent()"
    [class.overlap]="overlap()"
    [class.mobile]="isMobile()"
    [class.tablet]="isTablet()"
  >
    <a class="back-btn" (click)="back()" aria-label="label">
      <i nz-icon nzType="icons:arrow-left" class="svg-icon"></i>
      <span class="body-bold">{{ backLabel() }}</span>
    </a>
    <!-- <div class="header-content">
      <span class="body-bold">{{ title() }}</span>
    </div> -->
    @if (!isOnSettingsPage()) {
      <button
        class="ga-icon-button floating-btn"
        aria-label="settings"
        (click)="toSettings()"
      >
        <i nz-icon nzType="icons:more-information" class="noMarginRight"></i>
      </button>
    }
    <!-- banner Notification -->
    <app-banner-notification></app-banner-notification>
  </div>
}
